module.exports = __webpack_public_path__ + "img/global.81e69ea5.png";